import { createRouter, createWebHistory } from 'vue-router'
import { me } from './api'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    const user = await me()
    if (!user) return { name: 'login' }
  }
})

export default router
